import { Icon } from "../icons";
import { fmtDate } from "../helpers";
import { HoldToDelete } from "./shared";

export default function WorkoutDetailModal({ workout, allExercises, onClose, onEdit, onDelete }) {
  const wk = workout;
  const wkExIds = new Set((wk.exercises || []).map(Number));
  const exercises = allExercises.filter(e => wkExIds.has(Number(e.id)));
  return (
    <div className="modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div>
            <div className="modal-title">{wk.name}</div>
            <div style={{fontSize:10,color:"var(--muted)",marginTop:2}}>Created {fmtDate(wk.createdAt)}</div>
          </div>
          <button className="modal-close" onClick={onClose}><Icon.X/></button>
        </div>
        <div className="modal-body">
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
              {wk.description && <div style={{fontSize:12,color:"var(--muted)",lineHeight:1.7}}>{wk.description}</div>}
              {(wk.muscles||[]).length > 0 && (
                <div>
                  <div className="form-label" style={{marginBottom:6}}>Muscle Groups</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                    {wk.muscles.map(m => <span key={m} className="badge badge-slate">{m}</span>)}
                  </div>
                </div>
              )}
              <div>
                <div className="form-label" style={{marginBottom:8}}>Exercises ({exercises.length})</div>
                {exercises.length === 0 ? (
                  <div style={{fontSize:11,color:"var(--muted)"}}>No exercises assigned.</div>
                ) : (
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {exercises.map(ex => {
                      const bestSet = ex.sets.reduce((b,s) => s.weight>(b?.weight||0)||(s.weight===(b?.weight||0)&&s.reps>(b?.reps||0))?s:b, null);
                      return (
                        <div key={ex.id} className="section-block" style={{padding:"10px 14px"}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                            <div>
                              <div style={{fontWeight:600,fontSize:12}}>{ex.name}</div>
                              <div style={{fontSize:10,color:"var(--muted)",textTransform:"uppercase",letterSpacing:"0.06em",marginTop:1}}>{ex.muscle} · {ex.sets.length} sets</div>
                            </div>
                            <div style={{textAlign:"right"}}>
                              {ex.oneRepMax && <div style={{fontSize:11,color:"var(--accent)",fontWeight:600}}>{ex.oneRepMax} lbs 1RM</div>}
                              {bestSet && <div style={{fontSize:10,color:"var(--muted)"}}>Top: {bestSet.weight}×{bestSet.reps}</div>}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
        </div>
        <div className="modal-footer">
          <HoldToDelete onDelete={() => { onDelete(wk.id); onClose(); }} />
          <button className="btn btn-ghost btn-sm" onClick={()=>{onClose();onEdit(wk);}}><Icon.Edit/> Edit</button>
          <button className="btn btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
